import React from "react";
import Skeleton from "react-loading-skeleton";
import { useMediaQuery } from "react-responsive";
import { capitalizeFirstLetter } from "../../../../helpers/helpers";
import SubscriptionPaymentDetails from "./SubscriptionPaymentDetails";
import { useSelector } from "react-redux";

function ProfileHeader({ organizationData, loadings, profile }) {
  const isMobile = useMediaQuery({ query: "(max-width:730px)" });
  const { accountType } = useSelector((state) => state.account);

  return (
    <div
      className={`mt-1 p-1 white mb-1 cover valign-wrapper  flex-wrap ${
        isMobile ? " justify-center gap-1" : "space-between"
      }`}
    >
      <div
        className={` valign-wrapper flex-wrap gap-1 ${
          isMobile ? " justify-center" : ""
        } `}
      >
        {loadings ? (
          <Skeleton width={200} height={200} />
        ) : (
          <span className="p-1 circle border-dashed-style pointer">
            <img
              style={{ objectFit: "cover" }}
              className="materialboxed circle"
              width="120px"
              height="120px"
              src="/images/user.png"
              alt="profileImg"
            />
          </span>
        )}

        <div className={`grey-text ${isMobile ? "textAlign-center" : ""}`}>
          <h4 className="black-text margin-0px">
            {organizationData?.organizationName}
          </h4>
          <p className="font-18px bolder black-text">
            {capitalizeFirstLetter(organizationData?.role?.name) || (
              <Skeleton width={80} />
            )}
          </p>
          <p className="title bolder">
            Name:{" "}
            {capitalizeFirstLetter(profile?.name) || <Skeleton width={150} />}
          </p>
          <p className="title bolder">
            Email: {profile?.email || <Skeleton width={220} />}
          </p>
        </div>
      </div>
      {accountType === "trader/aggregator" && <SubscriptionPaymentDetails />}
    </div>
  );
}
export default ProfileHeader;
